var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 10,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadSales
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.CreateSalesDrawer.openDrawer();
      }
    }
  }, [_vm._v("新增销售项目")])], 1), _c('div', {
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "loading": _vm.tableLoading,
      "columns": _vm.columns,
      "data": _vm.tableData,
      "width": "1000"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (_ref) {
        var row = _ref.row;
        return _vm.currentUser.superAdmin || _vm.arrayIntersection(['factoryLeader', 'technologyLead', 'technology', 'allFactoryLeader'], _vm.currentUser.simpleRole).length > 0 ? [_c('Button', {
          attrs: {
            "type": "info",
            "ghost": "",
            "size": "small",
            "icon": "ios-funnel"
          },
          on: {
            "click": function ($event) {
              return _vm.$refs.RecipeDrawer.openDrawer(row);
            }
          }
        }, [_vm._v("配方")])] : undefined;
      }
    }], null, true)
  })], 1), _c('CreateSalesDrawer', {
    ref: "CreateSalesDrawer"
  }), _c('RecipeDrawer', {
    ref: "RecipeDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }